<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <CustomIcon
          :name="content.image"
          class="card-image bespoke-logo"
          v-if="content.image"
        />
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <ItemList
        :items="items"
        :action="(item) => action(item)"
        :type="componentType"
      />
      <div
        v-if="content.footer_message"
        class="card-footer-message"
        v-html="content.footer_message"
      ></div>
    </div>
  </div>
</template>
<script>
import ItemList from "@/components/ItemList.vue";
import CustomIcon from "@/components/CustomIcon.vue";

export default {
  props: {
    componentType: {
      type: String,
      required: false,
    },
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
    items: {
      type: Array,
      required: true,
      default: () => [
        {
          id: String,
          label: String,
          to: String,
          icon: String,
          text: String,
          description: String,
          isActive: Boolean,
          target_field: String,
          value: [String, Boolean, Array],
        },
      ],
    },
  },
  components: {
    ItemList,
    CustomIcon,
  },
};
</script>
